export { default, type FirstSectionProps } from './FirstSection';
